import { Component, OnInit } from '@angular/core';
import { Country } from '@angular-material-extensions/select-country';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AccountService } from '../services/account.service';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { MatDialog } from '@angular/material/dialog';
import { ResetpassmodalComponent } from '../resetpassmodal/resetpassmodal.component';
import { EncrDecrService } from '../services/encr-decr.service';
import { AppService } from '../services/app.service';

@Component({
  selector: 'app-accountsettings',
  templateUrl: './accountsettings.component.html',
  styleUrls: ['./accountsettings.component.scss']
})
export class AccountsettingsComponent implements OnInit {
  predefinedCountries: Country[] = [];

  countryFormControl = new FormControl();
  countryFormGroup: FormGroup;

  showResetPassword: boolean = false

  constructor(private EncDecService: EncrDecrService,
    private appService: AppService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private router: Router,
    private appComponent: AppComponent,
    private dialog: MatDialog) { }

  userInfo: any;

  async ngOnInit() {
    this.countryFormGroup = this.formBuilder.group({
      country: []
    });
    await this.accountService.getProfile().then((res: any) => {
      if (res.success) {
        console.log(res.user)
        this.userInfo = res.user
        console.log(this.userInfo.email)
        if (this.userInfo.email.includes("@facebook") || this.userInfo.email.includes("@gmail")){
          this.showResetPassword = false
        }
        else{this.showResetPassword = true}
        console.log(this.showResetPassword)
      }
    });
    this.appService.getCountries().then((res: any) => {
      if (res.success) {
        for (let i = 0; i < res.countries.length; i++) {
          this.predefinedCountries.push({
            name: res.countries[i].countryname,
            alpha2Code: res.countries[i].code,
            alpha3Code: res.countries[i].countrycode,
            numericCode: res.countries[i].id
          })
          if (res.countries[i].countryname == this.userInfo.country) {
            this.countryFormGroup.get('country').setValue(this.predefinedCountries[i]);
          }
        }
      }
    })
  }
  openResetPassword(): void {
    const dialogRef = this.dialog.open(ResetpassmodalComponent, {
      width: '350px',
      data: {},
      panelClass: 'resetpasswordmodal'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
    });
  }



  onCountrySelected($event: Country) {
    var formData: any = new FormData();
    formData.append("first_name", this.userInfo.first_name);
    formData.append("last_name", this.userInfo.last_name);
    formData.append("country", $event.name);
    this.accountService.updateProfile(formData).then((res) => {
      console.log(res)
    });
  }

  notification(event) {
    if (event.checked)
      this.accountService.notificationSetting(1);
    else
      this.accountService.notificationSetting(0);
  }


  deactivateAccount() {
    this.accountService.userDelete().then((res: any) => {
      if (res.success) {
        this.appComponent.logout();
      }
    })
  }


}
